import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import SEOHead from "../section/SeoHead";
import AboutHeroSection from "../section/AboutHeroSection";
import StorySection from "../section/StorySection";
import StatsSection from "../section/StatsSection";
import ValuesSection from "../section/ValuesSection";
import TeamSection from "../section/TeamSection";
import MissionSection from "../section/MissionSection";
import CtaSection from "../section/CtaSection";

const structuredData = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  name: "About Citizen Hub Immigration Services",
  description:
    "Learn about Citizen Hub Immigration Services - America's trusted immigration platform with expert form assistance, qualified lawyer matching, and direct payment processing.",
  mainEntity: {
    "@type": "LocalBusiness",
    name: "Citizen Hub Immigration Services",
    description:
      "Professional immigration services in the United States with expert assistance, lawyer matching, and direct payment processing.",
    telephone: "+1 3108802133",
    email: "info@citznhub.com",
    address: [
      {
        "@type": "PostalAddress",
        streetAddress: "123 Immigration Plaza, Suite 100",
        addressLocality: "Washington",
        addressRegion: "DC",
        postalCode: "20001",
      },
    ],
  },
};

export default function AboutUs() {
  const { t } = useTranslation();
  return (
    <motion.div
      className="min-h-screen bg-gray-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <SEOHead
        title={t("about_page.seo.title")}
        description={t("about_page.seo.description")}
        keywords={t("about_page.seo.keywords")}
        canonicalUrl="https://citizenhubimmigration.com/about"
        structuredData={structuredData}
      />

      <AboutHeroSection />
      <StorySection />
      <StatsSection />
      <ValuesSection />
      <TeamSection />
      <MissionSection />
      <CtaSection />
    </motion.div>
  );
}